<script setup>
import ProgressModuleGridRow from '@/components/dashboard/custom-dashboard/modules/progress-module/ProgressModuleGridRow'

defineOptions({
  name: 'ProgressModuleGridBody'
})

defineProps({
  elements: {
    type: Array,
    required: true
  }
})
</script>

<template>
  <div class="pmgb-Wrapper">
    <ProgressModuleGridRow v-for="element in elements" :key="element.id" :element />
  </div>
</template>

<style lang="scss" scoped></style>
